"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BATCH_OPTIONS_VALIDATORS: function() {
        return BATCH_OPTIONS_VALIDATORS;
    },
    BOT_AGENTS: function() {
        return BOT_AGENTS;
    },
    EVENTS_PROPERTIES_STRATEGY: function() {
        return EVENTS_PROPERTIES_STRATEGY;
    },
    IGNORED_EVENT_PROPERTIES: function() {
        return IGNORED_EVENT_PROPERTIES;
    },
    IGNORED_GLOBAL_PROPERTIES: function() {
        return IGNORED_GLOBAL_PROPERTIES;
    },
    LOG_LEVELS: function() {
        return LOG_LEVELS;
    },
    RESERVED_KEYWORD_PROPERTIES: function() {
        return RESERVED_KEYWORD_PROPERTIES;
    },
    SDK_HOST_URL: function() {
        return SDK_HOST_URL;
    },
    SUBDOMAIN_REGEXP: function() {
        return SUBDOMAIN_REGEXP;
    }
});
var SDK_HOST_URL = "https://rsconfig.jobteaser.com";
var SUBDOMAIN_REGEXP = /^([^.]+)\./;
var EVENTS_PROPERTIES_STRATEGY = {
    MERGE: "MERGE",
    OVERWRITE: "OVERWRITE"
};
var RESERVED_KEYWORD_PROPERTIES = [
    "anonymous_id",
    "id",
    "sent_at",
    "received_at",
    "timestamp",
    "original_timestamp",
    "event_text",
    "event",
    "session_id",
    "page_name"
];
var IGNORED_GLOBAL_PROPERTIES = [
    "utm_campaign",
    "utm_medium",
    "utm_content",
    "utm_source",
    "user_agent"
];
var IGNORED_EVENT_PROPERTIES = [
    "session_subdomain"
];
var LOG_LEVELS = {
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARN: "WARN"
};
var BATCH_OPTIONS_VALIDATORS = [
    {
        optionName: "batchableEventList",
        validator: function(option) {
            return Array.isArray(option);
        }
    },
    {
        optionName: "flushDelay",
        validator: function(option) {
            return typeof option === "number";
        }
    },
    {
        optionName: "maxBufferSize",
        validator: function(option) {
            return typeof option === "number";
        }
    }
];
var BOT_AGENTS = [
    "applebot",
    "bingbot",
    "chatgpt-user",
    "chrome-lighthouse",
    "developers.google.com/+/web/snippet",
    "discordbot",
    "facebookexternalhit",
    "google page speed",
    "google-inspectiontool",
    "googlebot",
    "googleother",
    "jobteaser-debug",
    "linkedinbot",
    "pinterest/0.",
    // https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
    "Prerender",
    "qwantify",
    "skypeuripreview",
    "slackbot",
    "twitterbot",
    "yahoo"
];

//# sourceMappingURL=constants.js.map